export const MIN_LEAVE_DAYS = 1;
export const MAX_LEAVE_DAYS = 270;
export const MEDICAL_LEAVE_REASON_THRESHOLD = 3;
export const DEFAULT_INSURANCE_TYPE = 'ZUS';
